import {useContext} from "react";
import {Link} from "react-router-dom";
import {BsChevronLeft} from "react-icons/bs";
import {FaFlag, FaTh} from "react-icons/fa";
import AppContext from "../../../AppContext";
import {useTranslation} from "react-i18next";

function Header({ sim, setSim, getQuestion, setQuestion, toggleGrid }) {
    const { t, i18n } = useTranslation();
    const app = useContext(AppContext);
    const formatTime = (duration) => {
        // Hours, minutes and seconds
        var hrs = ~~(duration / 3600);
        var mins = ~~((duration % 3600) / 60);
        var secs = ~~duration % 60;

        // Output like "1:01" or "4:03:59" or "123:03:59"
        var ret = "";

        if (hrs > 0) {
            ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
        }

        ret += "" + mins + ":" + (secs < 10 ? "0" : "");
        ret += "" + secs;
        return ret;
    }

    const gridButtonVisibility = () => {
        if(sim.finished)
            return 'none';

        switch(sim.currentStep) {
            case 2:
                return 'block'
        }
        return 'none'
    }

    const rightVisibility = () => {
        switch(sim.currentStep) {
            case 1:
            case 4:
            case 5:
                return 'none'
        }
        return 'flex'
    }
    const markQuestion = () => {
        if(sim.finished)
            return

        const q = getQuestion()
        if(q) {
            q.marked = !q.marked
            setQuestion(sim.currentQuestion, q)
        }
    }

    const goToFinish = () => {
        setSim({...sim, currentStep: 5, currentQuestion: 0})
    }
    let course_title = ''
    switch(app.user?.current_course) {
        case 1:
            course_title = 'BTH'
            break
        case 2:
            course_title = 'ATH'
            break
        case 3:
            course_title = 'AMTH'
            break
    }
    return (
        <div className="exam-sim-header">
            <div className="exam-sim-left">
                <div className="exam-sim-back">
                    <Link to="/">
                        <BsChevronLeft />
                    </Link>
                </div>
                <div className="exam-sim-title">
                    <h1>{app.user && app.user?.first_name ? app.user.first_name : t('sim.username')}</h1>
                    <span>{course_title} {t('sim.theory')}</span>
                </div>
            </div>
            <div className="exam-sim-right" style={{ display: rightVisibility() }}>
                <div className="exam-sim-mark" style={{ display: gridButtonVisibility() }}>
                    <button type="button" onClick={markQuestion} className={getQuestion()?.marked ? 'selected' : ''}>
                        <FaFlag />
                        <span>{t('sim.mark')}</span>
                    </button>
                </div>
                <div className="exam-sim-grid" style={{ display: gridButtonVisibility() }}>
                    <button type="button" onClick={toggleGrid} className={sim.gridVisible ? 'selected' : ''}>
                        <FaTh />
                        <span>{t('sim.overview')}</span>
                    </button>
                </div>
                <div className="exam-sim-grid" style={{ display: sim.finished && sim.currentStep <= 10 ? 'block' : 'none' }}>
                    <button type="button" onClick={goToFinish}>
                        <FaTh />
                        <span>{t('sim.overview')}</span>
                    </button>
                </div>
                <div className="exam-sim-time" style={{display: sim.timeRunning ? 'block' : 'none'}}>
                    <span>{t('sim.remainingTime')}</span>
                    <h1 className="answer-timer">{formatTime(sim.currentTimeLabel)}</h1>
                    <span>{t('sim.time')}</span>
                </div>
            </div>
        </div>
    );
}
export default Header;
